import ModelDelete from "@/pages/modals/_delete";
import { useDeleteTransactionTypeMutation } from "@/services/transactiontype.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function Delete() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteTransactionType, {isSuccess}] = useDeleteTransactionTypeMutation()

    const onAccept = () => {
        deleteTransactionType(location.state?.id || "")
    }

    useEffect(() => {
        if (isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_transaction_type")} content={t("modal.delete_transaction_type_content")} onAccept={onAccept} />
}
